import { FC } from "react";
import { UserProfilePreferencesView } from "../../../../modules/preferences/views/user-profile-preferences-view/UserProfilePreferencesView";

export const UserProfilePreferencesRoute: FC = () => {
    return (
        <UserProfilePreferencesView />
    )
}